var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#0057FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3901 5.17995V16.4799C21.3901 18.4599 19.7801 20.0699 17.8001 20.0699C15.8301 20.0699 14.2101 18.4599 14.2101 16.4799C14.2101 14.5099 15.8301 12.8999 17.8001 12.8999C18.6401 12.8999 19.3901 13.1899 20.0001 13.6699V7.71995L10.7901 10.3399V18.4099C10.7901 20.3899 9.17011 21.9999 7.20011 21.9999C5.22011 21.9999 3.61011 20.3899 3.61011 18.4099C3.61011 16.4399 5.22011 14.8299 7.20011 14.8299C8.03011 14.8299 8.78011 15.1199 9.39011 15.5899V6.74995C9.39011 5.27995 10.2801 4.13995 11.6901 3.75995L17.4701 2.17995C18.6401 1.85995 19.6301 1.96995 20.3301 2.50995C21.0401 3.03995 21.3901 3.93995 21.3901 5.17995Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/Music.4721a07e857ec65a5296542d24c247ae.svg";
export { ForwardRef as ReactComponent };